import { render, staticRenderFns } from "./termsOfUse.vue?vue&type=template&id=6c823922&scoped=true&"
import script from "./termsOfUse.vue?vue&type=script&lang=js&"
export * from "./termsOfUse.vue?vue&type=script&lang=js&"
import style0 from "./termsOfUse.vue?vue&type=style&index=0&id=6c823922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c823922",
  null
  
)

export default component.exports